(function () {
	'use strict';

	/**
	 * <mx-grouping-board
	 *
	 * 		items = "[
	 * 			{Sys-ObjectId:"b1344cfd-a3c7-ca19-498e-08d5cf715eb1",		Sys-DisplayName:"TSK00001 - 111",		Sys-EntityState:200, 	...	},
	 * 			{Sys-ObjectId:"b1344cfd-a3c7-ca19-498e-08d5cf715eb2",		Sys-DisplayName:"TSK00002 - 222",		Sys-EntityState:201, 	...	},  // will not be visible because `Sys-EntityState:201` not it the list of groups
	 * 			{Sys-ObjectId:"b1344cfd-a3c7-ca19-498e-08d5cf715eb3",		Sys-DisplayName:"TSK00003 - 333",		Sys-EntityState:202, 	...	},
	 * 			{Sys-ObjectId:"b1344cfd-a3c7-ca19-498e-08d5cf715eb4",		Sys-DisplayName:"TSK00004 - 444",		Sys-EntityState:202, 	...	},
	 * 			{Sys-ObjectId:"b1344cfd-a3c7-ca19-498e-08d5cf715eb5",		Sys-DisplayName:"TSK00005 - 555",		Sys-EntityState:204, 	...	}
	 * 		]"
	 *
	 * 		columns = "[									// Here keys: `value` and `title` are mandatory
	 * 			{value: 200, title: "New"},
	 * 			{value: 202, title: "In Progress"},
	 * 			{value: 204, title: "Closed"}
	 * 		]"
	 *
	 * 		item-column-key = "Sys-EntityState"
	 *
	 *		on-item-changed="vm.doSomething(item)"
	 *
	 *		data-loading="{{true}}"
	 *
	 * ></mx-grouping-board>
	 *
	 */

	angular.module('mx.SolutionBuilderAgent').component('mxGroupingBoard', {
		bindings: {
			items: '<',
			columns: '<',
			itemColumnKey: '@',
			itemPriorityKey: '@', // not mandatory
			onItemChanged: '&', // callback with next agrs: (<item>, <new column value>, <item before>, <item after>);
			loading: '<',
			itemTemplate: '<',
			sharedScope: '<',
			sharedScopeAs: '@',
			enableDragging: '<',
		},
		transclude: true,
		templateUrl: 'workspaces/SolutionBuilderAgent/components/mx-grouping-board/mx-grouping-board.html',
		controllerAs: 'vm',
		controller: MxGroupingBoard,
	});

	MxGroupingBoard.$inject = ['$scope', 'mx.shell.View'];

	function MxGroupingBoard($scope, MxView) {
		var vm = this;
		vm.groupedItem = {};

		$scope.$watchGroup(['vm.items', 'vm.itemColumnKey'], function () {
			if (vm.items && Array.isArray(vm.items)) {
				vm.groupedItem = angular.extend(vm.groupedItem, _.groupBy(vm.items, vm.itemColumnKey));
				if (vm.itemTemplate) {
					_generateItemViews(vm.items, vm.itemTemplate);
				}
			}
		});

		$scope.$watch('vm.itemTemplate', function (newItemTemplate, oldItemTemplate) {
			if (typeof newItemTemplate === 'string' && newItemTemplate !== oldItemTemplate && Array.isArray(vm.items)) {
				_generateItemViews(vm.items, newItemTemplate, true);
			}
		});

		$scope.$watch('vm.columns', function () {
			if (Array.isArray(vm.columns)) {
				vm.columns.forEach(function (col) {
					if (!vm.groupedItem[col.value]) {
						vm.groupedItem[col.value] = [];
					}
				});
			}
		});

		vm.onMove = function ($item, $partFrom, $partTo, $indexFrom, $indexTo) {
			// When Column is changed
			for (var columnVal in vm.groupedItem) {
				if (vm.groupedItem[columnVal] === $partTo) {
					// update item
					if (typeof $item[vm.itemColumnKey] === 'number') {
						columnVal = parseInt(columnVal);
					}
					$item[vm.itemColumnKey] = columnVal;

					// trigger callback
					vm.onItemChanged({
						item: $item,
						newColumnValue: columnVal,
						itemBefore: $partTo[$indexTo - 1],
						itemAfter: $partTo[$indexTo + 1],
					});
				}
			}
		};

		function _generateItemViews(items, template, forceRegen) {
			items.forEach(function (item, i) {
				item.__view =
					item.__view && !forceRegen
						? item.__view
						: new MxView({
								id: 'mxGroupingBoardItemViewID' + i + Math.random(),
								template: template,
								locals: item,
								controllerAs: 'item',
								controller: [
									'$scope',
									function ($scope) {
										$scope[vm.sharedScopeAs] = vm.sharedScope;
									},
								],
						  });
			});
		}
	}
})();
